import CloudinaryReportTableMain from "./cloudinary-report-main-table";


const CloudinaryReportTables = {
    Main : CloudinaryReportTableMain
}

export default CloudinaryReportTables;